import { useCallback, useEffect } from 'react';
import debounce from 'lodash.debounce';
import { useAppDispatch, useAppState } from '@/store';
import { categoriesSelector } from '../feature/selectors';
import { getCategoriesAutocomplete } from '../feature/actionCreators';
import { ICategory } from '@/models/categories.model';

type TUseCategoriesAutocomplete = {
  list: ICategory[] | null;
  onSearch: (value?: string) => void;
};

type TProps = {
  hasChildren?: '1' | '0';
};

const useCategoriesAutocomplete = ({ hasChildren }: TProps): TUseCategoriesAutocomplete => {
  const { categoriesAutocomplete, isLoadingCategories, error } = useAppState(categoriesSelector);
  const dispatch = useAppDispatch();

  const onCategoriesSearch = useCallback(
    debounce((name?: string) => {
      dispatch(
        getCategoriesAutocomplete({
          name: name,
          limit: 500,
          ...(hasChildren && { has_children: hasChildren }),
        }),
      );
    }, 500),
    [hasChildren],
  );

  useEffect(() => {
    if (!categoriesAutocomplete && !error && !isLoadingCategories) {
      dispatch(getCategoriesAutocomplete({ limit: 500, ...(hasChildren && { has_children: hasChildren }) }));
    }
  }, [categoriesAutocomplete, error, hasChildren]);

  return { list: categoriesAutocomplete, onSearch: onCategoriesSearch };
};

export default useCategoriesAutocomplete;
